import { memo } from "react";

function IVRR() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 0.10064C14.9625 0.108356 14.9255 0.116481 14.8891 0.125C13.9791 0.337724 13.4067 0.811962 12.9163 1.11265C12.4374 1.40617 11.8586 1.67442 10.7143 1.67442C9.36682 1.67442 8.75935 1.30492 8.16284 0.922965C7.48352 0.487982 6.7737 0 5.35714 0C3.94058 0 3.23077 0.487982 2.55144 0.922965C1.95493 1.30492 1.34746 1.67442 0 1.67442V3.53488C1.5989 3.53488 2.40132 3.06715 3.11227 2.61192C3.74032 2.20976 4.23593 1.86047 5.35714 1.86047C6.47835 1.86047 6.97397 2.20976 7.60202 2.61192C8.31296 3.06715 9.11539 3.53488 10.7143 3.53488C12.0517 3.53488 12.8143 3.20879 13.4572 2.81468C14.0537 2.44899 14.3813 2.15514 15 1.98728V0.10064Z"
        fill="currentColor"
      />
      <path
        d="M15 4.56576C14.9625 4.57347 14.9255 4.5816 14.8891 4.59012C13.9791 4.80284 13.4067 5.27708 12.9163 5.57776C12.4374 5.87128 11.8586 6.13953 10.7143 6.13953C9.36682 6.13953 8.75935 5.77004 8.16284 5.38808C7.48352 4.9531 6.7737 4.46512 5.35714 4.46512C3.94058 4.46512 3.23077 4.9531 2.55144 5.38808C1.95493 5.77004 1.34746 6.13953 0 6.13953V8C1.5989 8 2.40132 7.53227 3.11227 7.07703C3.74032 6.67487 4.23593 6.32558 5.35714 6.32558C6.47835 6.32558 6.97397 6.67487 7.60202 7.07703C8.31296 7.53227 9.11539 8 10.7143 8C12.0517 8 12.8143 7.6739 13.4572 7.2798C14.0537 6.91411 14.3813 6.62025 15 6.45239V4.56576Z"
        fill="currentColor"
      />
      <path
        d="M27.7158 1.71582L9.21847 20.2132L7.78683 18.7815L26.2842 0.28418L27.7158 1.71582Z"
        fill="currentColor"
      />
      <path
        d="M5.28961 19.3577L4.64942 22.5894H6.63945L7 23.3101L3.51326 28L2.71127 27.6423L3.35234 24.4106H1.36142L1 23.6899L4.48674 19L5.28961 19.3577Z"
        fill="currentColor"
      />
      <path
        d="M28 22.0508C27.9701 22.057 27.9406 22.0634 27.9115 22.0702C27.1857 22.2399 26.7291 22.6182 26.3379 22.8581C25.9559 23.0922 25.4942 23.3062 24.5814 23.3062C23.5066 23.3062 23.022 23.0114 22.5462 22.7068C22.0043 22.3598 21.4381 21.9705 20.3082 21.9705C19.1782 21.9705 18.612 22.3598 18.0701 22.7068C17.5943 23.0114 17.1097 23.3062 16.0349 23.3062V24.7902C17.3103 24.7902 17.9504 24.4171 18.5175 24.054C19.0185 23.7332 19.4138 23.4546 20.3082 23.4546C21.2025 23.4546 21.5979 23.7332 22.0988 24.054C22.6659 24.4171 23.306 24.7902 24.5814 24.7902C25.6482 24.7902 26.2565 24.5301 26.7694 24.2157C27.2452 23.924 27.5065 23.6896 28 23.5557V22.0508Z"
        fill="currentColor"
      />
      <path
        d="M28 25.2606C27.9701 25.2667 27.9406 25.2732 27.9115 25.28C27.1857 25.4497 26.7291 25.828 26.3379 26.0678C25.9559 26.302 25.4942 26.516 24.5814 26.516C23.5066 26.516 23.022 26.2212 22.5462 25.9165C22.0043 25.5696 21.4381 25.1803 20.3082 25.1803C19.1782 25.1803 18.612 25.5696 18.0701 25.9165C17.5943 26.2212 17.1097 26.516 16.0349 26.516V28C17.3103 28 17.9504 27.6269 18.5175 27.2638C19.0185 26.943 19.4138 26.6644 20.3082 26.6644C21.2025 26.6644 21.5979 26.943 22.0988 27.2638C22.6659 27.6269 23.306 28 24.5814 28C25.6482 28 26.2565 27.7399 26.7694 27.4255C27.2452 27.1338 27.5065 26.8994 28 26.7655V25.2606Z"
        fill="currentColor"
      />
      <path
        d="M19.172 12.4706C19.172 12.4706 22.3091 16.1035 22.3091 17.8469C22.3091 19.5902 20.9045 21.0035 19.172 21.0035C17.4394 21.0035 16.0349 19.5903 16.0349 17.8469C16.0349 16.1035 19.172 12.4706 19.172 12.4706Z"
        fill="currentColor"
      />
      <path
        d="M25.5709 14.8827C25.5709 14.8827 26.5829 16.0546 26.5829 16.6169C26.5828 17.1793 26.1298 17.6352 25.5709 17.6352C25.0121 17.6352 24.559 17.1793 24.559 16.6169C24.559 16.0546 25.5709 14.8827 25.5709 14.8827Z"
        fill="currentColor"
      />
      <path
        d="M24.2209 17.8236C24.2209 17.8236 25.2328 18.9954 25.2328 19.5578C25.2328 20.1201 24.7798 20.576 24.2209 20.576C23.662 20.576 23.209 20.1202 23.209 19.5578C23.209 18.9954 24.2209 17.8236 24.2209 17.8236Z"
        fill="currentColor"
      />
      <path
        d="M26.9881 17.8255C26.9881 17.8255 28 18.9974 28 19.5598C28 20.1221 27.5469 20.578 26.9881 20.578C26.4292 20.578 25.9762 20.1221 25.9761 19.5598C25.9761 18.9974 26.9881 17.8255 26.9881 17.8255Z"
        fill="currentColor"
      />
      <path
        d="M10.5303 10.5303L7 14.0605L3.46973 10.5303L4.53027 9.46973L7 11.9395L9.46973 9.46973L10.5303 10.5303Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default memo(IVRR);
